<template>
    <legal-page-layout
        :title="$t('legal.title')"
        :updated="$t('legal.updated')"
        :paragraphs="$t('legal.paragraphs')"
    ></legal-page-layout>
</template>

<script>
import LegalPageLayout from './LegalPageLayout.vue';

export default {
    name: 'Legal',
    components: { LegalPageLayout },
    data: () => ({
        translations: {
            en: {
                legal: {
                    title: 'Legal Notice',
                    updated: 'Last updated: September 10, 2026',
                    paragraphs: [
                        {
                            title: 'Site owner',
                            text: `In compliance with Spanish Law 34/2002 (LSSI-CE), we inform you that this website, https://nukliapp.com, and the Nukli service are operated by:
- Owner: Pasqual Mas Baulas (sole trader)
- Tax ID (NIF): 47998845F
- Address: Gran Via de les Corts Catalanes 679, 1º 2ª, 08013 Barcelona, Spain
- Contact: hola@nukliapp.com
- Activity: development and operation of Nukli, a desktop email client with AI-assisted features and its associated subscription service.`
                        },
                        {
                            title: 'Use of the website',
                            text: `Accessing and using this website makes you a user of it. As a user you agree to use the website and the service in accordance with the law, these terms and good faith, and in particular not to:
- use the website or the service for unlawful activities or activities that infringe third-party rights;
- carry out advertising or commercial exploitation by sending messages under a false identity;
- introduce content or perform actions that could damage, overload or impair the website or the service.
The conditions that govern the use of the Nukli service itself are in the Terms of Service (https://nukliapp.com/politics/terms).`
                        },
                        {
                            title: 'Intellectual property',
                            text: `The Nukli software, brand, logo, website design and contents are the property of the owner or are licensed to them. Reproduction, distribution or public communication beyond normal use of the service requires prior written authorization.`
                        },
                        {
                            title: 'Liability and links',
                            text: `We are not responsible for the content of third-party websites that may be linked from this website. Accessing them is at the user's own risk.
We work to keep the information on this website accurate and up to date, but we cannot guarantee the absence of errors, which we will correct as soon as we become aware of them.`
                        },
                        {
                            title: 'Data protection',
                            text: `The processing of personal data through this website and the Nukli service is described in the Privacy Policy (https://nukliapp.com/politics/privaci), which complies with the EU General Data Protection Regulation (GDPR) and Spanish Organic Law 3/2018 (LOPDGDD).`
                        },
                        {
                            title: 'Applicable law',
                            text: `This legal notice is governed by Spanish law.`
                        }
                    ]
                }
            },
            es: {
                legal: {
                    title: 'Aviso Legal',
                    updated: 'Última actualización: 10 de septiembre de 2026',
                    paragraphs: [
                        {
                            title: 'Titular del sitio',
                            text: `En cumplimiento de la Ley 34/2002 (LSSI-CE), te informamos de que este sitio web, https://nukliapp.com, y el servicio Nukli están operados por:
- Titular: Pasqual Mas Baulas (empresario individual / autónomo)
- NIF: 47998845F
- Domicilio: Gran Via de les Corts Catalanes 679, 1º 2ª, 08013 Barcelona, España
- Contacto: hola@nukliapp.com
- Actividad: desarrollo y explotación de Nukli, un cliente de correo de escritorio con funciones asistidas por IA y su servicio de suscripción asociado.`
                        },
                        {
                            title: 'Uso del sitio web',
                            text: `El acceso y uso de este sitio web te convierte en usuario del mismo. Como usuario te comprometes a usar la web y el servicio conforme a la ley, a estas condiciones y a la buena fe, y en particular a no:
- usar la web o el servicio para actividades ilícitas o que infrinjan derechos de terceros;
- realizar actividades publicitarias o de explotación comercial remitiendo mensajes con identidad falsa;
- introducir contenido o realizar acciones que puedan dañar, sobrecargar o deteriorar la web o el servicio.
Las condiciones que rigen el uso del propio servicio Nukli están en los Términos del Servicio (https://nukliapp.com/politics/terms).`
                        },
                        {
                            title: 'Propiedad intelectual',
                            text: `El software, la marca, el logo, el diseño de la web y los contenidos de Nukli son propiedad del titular o están licenciados a su favor. Su reproducción, distribución o comunicación pública más allá del uso normal del servicio requiere autorización previa por escrito.`
                        },
                        {
                            title: 'Responsabilidad y enlaces',
                            text: `No nos hacemos responsables del contenido de sitios web de terceros que puedan enlazarse desde esta web. El acceso a ellos es responsabilidad del usuario.
Trabajamos para que la información de esta web sea exacta y esté actualizada, pero no podemos garantizar la ausencia de errores, que corregiremos tan pronto los conozcamos.`
                        },
                        {
                            title: 'Protección de datos',
                            text: `El tratamiento de datos personales a través de esta web y del servicio Nukli se describe en la Política de Privacidad (https://nukliapp.com/politics/privaci), que cumple con el Reglamento General de Protección de Datos de la UE (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD).`
                        },
                        {
                            title: 'Ley aplicable',
                            text: `Este aviso legal se rige por la legislación española.`
                        }
                    ]
                }
            },
            ca: {
                legal: {
                    title: 'Avís Legal',
                    updated: 'Última actualització: 10 de setembre de 2026',
                    paragraphs: [
                        {
                            title: 'Titular del lloc',
                            text: `En compliment de la Llei 34/2002 (LSSI-CE), t'informem que aquest lloc web, https://nukliapp.com, i el servei Nukli estan operats per:
- Titular: Pasqual Mas Baulas (empresari individual / autònom)
- NIF: 47998845F
- Domicili: Gran Via de les Corts Catalanes 679, 1r 2a, 08013 Barcelona, Espanya
- Contacte: hola@nukliapp.com
- Activitat: desenvolupament i explotació de Nukli, un client de correu d'escriptori amb funcions assistides per IA i el seu servei de subscripció associat.`
                        },
                        {
                            title: 'Ús del lloc web',
                            text: `L'accés i ús d'aquest lloc web et converteix en usuari del mateix. Com a usuari et compromets a usar la web i el servei conforme a la llei, a aquestes condicions i a la bona fe, i en particular a no:
- usar la web o el servei per a activitats il·lícites o que infringeixin drets de tercers;
- realitzar activitats publicitàries o d'explotació comercial remetent missatges amb identitat falsa;
- introduir contingut o realitzar accions que puguin danyar, sobrecarregar o deteriorar la web o el servei.
Les condicions que regeixen l'ús del propi servei Nukli són als Termes del Servei (https://nukliapp.com/politics/terms).`
                        },
                        {
                            title: 'Propietat intel·lectual',
                            text: `El software, la marca, el logo, el disseny de la web i els continguts de Nukli són propietat del titular o estan llicenciats al seu favor. La seva reproducció, distribució o comunicació pública més enllà de l'ús normal del servei requereix autorització prèvia per escrit.`
                        },
                        {
                            title: 'Responsabilitat i enllaços',
                            text: `No ens fem responsables del contingut de llocs web de tercers que es puguin enllaçar des d'aquesta web. L'accés a ells és responsabilitat de l'usuari.
Treballem perquè la informació d'aquesta web sigui exacta i estigui actualitzada, però no podem garantir l'absència d'errors, que corregirem tan aviat els coneguem.`
                        },
                        {
                            title: 'Protecció de dades',
                            text: `El tractament de dades personals a través d'aquesta web i del servei Nukli es descriu a la Política de Privacitat (https://nukliapp.com/politics/privaci), que compleix amb el Reglament General de Protecció de Dades de la UE (RGPD) i la Llei Orgànica 3/2018 (LOPDGDD).`
                        },
                        {
                            title: 'Llei aplicable',
                            text: `Aquest avís legal es regeix per la legislació espanyola.`
                        }
                    ]
                }
            }
        }
    }),
    methods: {
        $t(key) {
            const lang = this.$root.currentLanguage || 'ca';
            const dict = this.translations[lang] || this.translations.en;
            const translation = key.split('.').reduce((obj, i) => obj && obj[i], dict);
            return translation || key;
        }
    }
};
</script>
